// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1Wnf0","rootCenter":"LoadMoreObserver_rootCenter__2W1xe","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__297ud"};